import React from 'react';
import Modal from '@vestingSafe/src/Components/Modal';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close_2.svg';
import icSuccess from 'assets/svg/ic_success_V2.svg';
import Button_V2 from '@vestingSafe/src/Components/Button_V2';
import { CurrencyType, formatCurrency } from '@wolffun/system-currency';
import { BN } from 'bn.js';

const ModalClaimDetail = ({
  onClose,
  claimedAmount,
  feeAmount
}) => {
  const claimAmountBN = new BN((claimedAmount === null || claimedAmount === void 0 ? void 0 : claimedAmount.value) || '');
  const feeAmountBN = new BN((feeAmount === null || feeAmount === void 0 ? void 0 : feeAmount.value) || '');
  const totalClaimed = {
    token: CurrencyType.GTHG,
    value: claimAmountBN.add(feeAmountBN).toString()
  };
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Complete")), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, /*#__PURE__*/React.createElement("span", null, "Now you can check your Ingame Thetan Coin in Wallet")), /*#__PURE__*/React.createElement("div", {
    className: styles.claimedAmount
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Claimed")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, claimedAmount ? formatCurrency(totalClaimed, {
    withCurrency: true
  }) : ''))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button_V2, {
    className: styles.button,
    title: "I got it",
    onClick: onClose
  }))));
};

export default ModalClaimDetail;